import {Pipe, PipeTransform} from '@angular/core';
import {ConsentUseCaseLetterEnum} from '../../views/secured/views/modules/consent-use-case/enums/consent-use-case.enum-letter';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'intensityToLevel'
})
export class IntensityToLevelPipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }

    transform(value: string): string {
        switch (value) {
            case 'A-Level':
                return ConsentUseCaseLetterEnum.B;
            case this.translate.instant('ONBOARDING.USE_CASE_LEVELS.SURFACE'):
                return ConsentUseCaseLetterEnum.C;
            case this.translate.instant('ONBOARDING.USE_CASE_LEVELS.NORMAL'):
                return ConsentUseCaseLetterEnum.D;
            case this.translate.instant('ONBOARDING.USE_CASE_LEVELS.DETAILED'):
                return ConsentUseCaseLetterEnum.E;
            case this.translate.instant('ONBOARDING.USE_CASE_LEVELS.INTENSIV'):
                return ConsentUseCaseLetterEnum.F;
        }
        return ConsentUseCaseLetterEnum.D;
    }
}
